<p-toast></p-toast>
<div class="position-relative">

    <router-outlet></router-outlet>
</div>
<p-toast></p-toast>